import { Injectable } from "@angular/core";
import { ApiDataService } from "@services/http/ApiDataService";
import { map, Observable, of } from "rxjs";
import { AiOutputLanguageModel } from "../shared/models/AiOutputLanguageModel";
import { AiSettingsModel } from "../shared/models/AiSettingModel";
import { AiSettingUpdateModel } from "../shared/models/AiSettingUpdateModel";

@Injectable()
export class AiSettingsService extends ApiDataService {
    private isEnabledCache: boolean = null;

    constructor() {
        super("ai/settings");
    }

    isEnabled(): Observable<boolean> {
        if (this.isEnabledCache !== null) {
            return of(this.isEnabledCache);
        }

        return this.get<boolean>("/enabled").pipe(
            map((enabled) => {
                this.isEnabledCache = enabled;
                return enabled;
            }),
        );
    }

    getSettings(): Observable<AiSettingsModel[]> {
        return this.get<AiSettingsModel[]>();
    }

    getOutputLanguages(): Observable<AiOutputLanguageModel[]> {
        return this.get<AiOutputLanguageModel[]>("/output-languages");
    }

    storeSetting(setting: AiSettingUpdateModel) {
        return this.put(setting);
    }
}
